import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.model("VoiceTerminal", "ExpressionTerminal", {
    initialize: function() {
      // need to grab reference to the backdraft app - and the model actually uses the `app` reference internally (!)
      var app = Backdraft.app("Shared/ExpressionBuilder");
      this.set('voiceKeywords', new app.Models.VoiceKeyword(this.attributes, { parse: true }));

      this.listenTo(this.get('voiceKeywords'), 'sync', _.bind(this._updateKeywordAttributes, this));
    },

    type: function() {
      return 'Voice';
    },

    text: function() {
      return (
        "voice_signal = " + this.get('voiceKeywords').toExpressionText()
      );
    },

    _updateKeywordAttributes: function() {
      this.set(this.get('voiceKeywords').toJSON());
    }
  });
});
